import _ from 'lodash';
import React from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import clsx from 'clsx';

import './Popovers.less';
import './CustomTooltip.less';

const DEFAULT_PLACEMENT = 'right';

export const iconTypes = {
  INFO: 'icon-bzm-info',
  HELP: 'icon-bzm-help',
};

export const tooltipStyles = {
  normal: '',
  bold: 'bold',
  italic: 'italic',
};

export const tooltipIcons = {
  success: 'icon-bzm-success',
  warning: 'icon-bzm-caution',
  error: 'icon-bzm-danger',
};

export const tooltipModeLight = 'light';

interface IOverlayTooltipProps {
  id: string;
  className?: string;
  text: string | JSX.Element;
  title?: string;
  tooltipClassName?: string;
  tooltipIcon?: 'icon-bzm-success' | 'icon-bzm-caution' | 'icon-bzm-danger';
}

export const OverlayTooltip: React.FC<IOverlayTooltipProps> = (props: IOverlayTooltipProps) => {
  const { id, tooltipClassName, tooltipIcon, title, text } = props;
  const popoverProps = _.omit(props, ['id', 'tooltipClassName', 'tooltipIcon', 'title', 'text']);
  const classes = clsx(popoverProps.className, tooltipClassName);

  return (
    <Popover {...popoverProps} id={id} className={classes}>
      <div className="tooltip-title">
        {tooltipIcon && <i className="tooltip-title-icon" />}
        {title}
      </div>
      <div className="tooltip-text">{text}</div>
    </Popover>
  );
};

interface ICustomTooltipProps {
  className?: string;
  children?: JSX.Element;
  iconClassName?: string;
  iconType?: string;
  id: string;
  placement?: string;
  text: string | JSX.Element;
  title?: string;
  tooltipIcon?: 'icon-bzm-success' | 'icon-bzm-caution' | 'icon-bzm-danger';
  tooltipMode?: 'dark' | 'light';
  tooltipStyle?: '' | 'bold' | 'italic';
}

export const CustomTooltip: React.FC<ICustomTooltipProps> = (props: ICustomTooltipProps) => {
  const tooltipClassName = clsx('blazemeter-tooltip', props.className, props.tooltipStyle, props.tooltipMode);

  const overlay = (
    <OverlayTooltip
      id={props.id}
      tooltipClassName={tooltipClassName}
      tooltipIcon={props.tooltipIcon}
      title={props.title}
      text={props.text}
    />
  );

  const iconClassName = clsx(props.iconType, 'custom-tooltip-icon', props.iconClassName);
  return (
    <OverlayTrigger trigger="click" placement="right" overlay={overlay}>
      {props.children || <i className={iconClassName} />}
    </OverlayTrigger>
  );
};

CustomTooltip.defaultProps = {
  placement: DEFAULT_PLACEMENT,
  tooltipStyle: '',
  tooltipMode: tooltipModeLight,
};

export default CustomTooltip;
